export const nextPage = currentPage => dispatch => {
  dispatch({
    type: "NEXT_PAGE",
    payload: currentPage + 1
  });
};
